import * as React from 'react';
import { observer } from 'mobx-react';
import { injectStripe } from 'react-stripe-elements';
import CardSection from './CardSection';
import { Button, Alert, Row, Col } from 'reactstrap';
import { translate } from 'react-i18next';
import PaymentService from '../Services/PaymentService';

@observer
class CheckoutForm extends React.Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      submitting: false,
    };
  }
  handleSubmit = (ev) => {
    ev.preventDefault();
  
    if (this.props.stripe && this.props.elements) {
      this.setState({ submitting: true });
      const booking = this.props.booking;
      const firstName = (booking && booking.first_name) ? booking.first_name : ''; 
      const lastName = (booking && booking.last_name) ? booking.last_name : '';  
  
      const fullName = `${firstName} ${lastName}`.trim();
      
      this.props.stripe.createToken({
        type: 'card',
        card: {
          name: fullName || 'Guest',
        },
      }).then(({ token, error }) => {
        if (error) {
          this.setState({
            error: `Token creation failed: ${error.message}`,
            submitting: false,
          });
          console.log('[error]', error);
        } else {
          this.props.handlePayment(token);
        }
      });
  }
};
  
  

  submitForm = () => {
    if (this.formRef.current) {
      this.formRef.current.submit();
    }
  };

  render() {
    const { t, booking, showSubmitButton = true } = this.props;
    const { error, submitting } = this.state;

    return (
      <form id="bookingForm" onSubmit={this.handleSubmit}>
        <CardSection />
        {
          error && <Row><Col lg={12}><Alert color='danger'>{error}</Alert></Col></Row>
        }
        {showSubmitButton && (
          <Button
            color='primary'
            block
            disabled={booking.invalid || submitting}
          >
            {submitting ? t('Sending...') : (this.props.buttonText || t('Book'))}
          </Button>
        )}
      </form>
    );
  }
}

export default translate()(injectStripe(CheckoutForm));



// WEBPACK FOOTER //
// ./src/App/Checkout/CheckoutForm.js